import { IconPropType } from ".";

export const SuccessIcon: React.FC<IconPropType> = ({ width = 16 , height = 16 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
  <g clipPath="url(#clip0_1076_63344)">
    <path d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 0.8C4.02355 0.8 0.8 4.02355 0.8 8C0.8 11.9765 4.02355 15.2 8 15.2C11.9765 15.2 15.2 11.9765 15.2 8C15.2 4.02355 11.9765 0.8 8 0.8Z" fill="#0BD084"/>
    <path d="M11.3172 5.31719C11.4734 5.16098 11.7266 5.16098 11.8828 5.31719C12.039 5.4734 12.039 5.7266 11.8828 5.88281L7.2 10.5656L4.11719 7.48281C3.96098 7.3266 3.96098 7.0734 4.11719 6.91719C4.2734 6.76098 4.5266 6.76098 4.68281 6.91719L7.2 9.43437L11.3172 5.31719Z" fill="#0BD084"/>
  </g>
  <defs>
    <clipPath id="clip0_1076_63344">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
)